import { createSharpZoomPlan, type SharpZoomPlan } from "./plan.ts";

/**
 * The switch of sharp scaling for an in-between world zoom (`module.ts`) and what it last did, as plain data, so
 * whoever mounts the module can read and switch it without holding the module: the gallery's `sharp-zoom` page
 * through its links, and the game page through `window.game.sharpZoom` (`game/report.ts`) for its browser tests.
 */

/**
 * A switch for the module and what it last did, shared with whoever mounted it.
 */
export interface SharpZoomControl {
  /** Whether an in-between zoom is resampled; false leaves the world camera to draw it with nearest sampling. */
  enabled: boolean;
  /** The plan of the frame last updated; inactive while the zoom is whole or the switch is off. */
  readonly plan: SharpZoomPlan;
}

/**
 * A control that starts enabled.
 *
 * @returns The control.
 */
export function createSharpZoomControl(): SharpZoomControl {
  return { enabled: true, plan: createSharpZoomPlan() };
}
